module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image9.a131f2cd.jpg";